import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
// import { stats } from '../data/services';
// import WorkingHours from './WorkingHours';
import MetricDisplay from './MetricDisplay';
import { Rocket, Users, Clock, Presentation } from 'lucide-react'; // Importing icons from lucide-react
import { RxFontStyle } from 'react-icons/rx';

const Stats = () => {
  // Estado para las horas laboradas (inicia en 2.5 millones)
  const [laborHours, setLaborHours] = useState(2500000);

  useEffect(() => {
    // Incremento aleatorio suave cada 2.5 segundos para simular actividad real
    const interval = setInterval(() => {
      setLaborHours(prev => prev + Math.floor(Math.random() * 5) + 1);
    }, 2500);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-5 bg-gradient-to-r from-slate-700 via-slate-900 to-slate-700 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Trusted by Industry
            <span className="block bg-gradient-to-r from-orange-400 to-red-400 bg-clip-text text-transparent">
              Leaders
            </span>
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Our track record speaks for itself. Here's what we've accomplished together.
          </p>
        </motion.div>

        {/* Display numnbers new format */}
        <div className="bg-transparent flex items-center justify-center p-8">
          <motion.div
            className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl w-full"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <MetricDisplay
              title="Training"
              IconComponent={Presentation} // Using Rocket icon
              value={3403}
              unit="#"
              label="Trainings to date"
              decimals={0}
              delay={100}
            />
            <MetricDisplay
              title="Employees"
              IconComponent={Users} // Using Users icon
              value={4000}
              unit="+"
              label="Our academy oversee workforce development"
              decimals={0}
              delay={300}
            />
            <MetricDisplay
              title="Labor Hours"
              IconComponent={Clock}
              value={laborHours} // Ahora el número GRANDE es el exacto
              exactValue={laborHours / 1000000} // El Pequeño es el de millones
              unit=""
              label="Managed by MDX to date"
              decimals={0} // Sin decimales para el número grande (es el entero)
              delay={500}
            />
          </motion.div>
        </div>

        {/* Bottom Message */}
        <motion.div
          className="text-center mt-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          viewport={{ once: true }}
        >
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-4">
              Ready to Join Our Success Stories?
            </h3>
            <p className="text-gray-300 mb-6">
              Let's work together to create a safer, more compliant workplace for your team.
            </p>
            <motion.button
              className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-8 py-3 rounded-full font-bold hover:shadow-xl transition-all duration-300"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <div className="flex items-center gap-4">
                <a href="mailto:info@mdxsafetyinc.com" className="flex items-center gap-2 text-white hover:text-[#a1a09a] transition-colors">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                  <span className="font-bold">Start Your Safety Journey</span>
                </a>
              </div>

            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Stats;